import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import cn from 'classnames';
import { ConfirmationModal, Typography, extractPureTextFromRichText, useOverlayContext, TextButton } from 'seagull';
import { inlineTemplateVariableBlots } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
import ServiceDescriptionContent from '~/components/ServiceDescriptionContent/ServiceDescriptionContent';
import styles from './ServiceDescription.module.scss';
export default function ServiceDescription(param) {
    let { service, testId, isMobile, showReadMoreButton = true } = param;
    var _service_bundle;
    const [isDescriptionOverflowing, setIsDescriptionOverflowing] = useState(false);
    const { showModal } = useOverlayContext();
    const hasBundleDescription = useMemo(()=>{
        var _service_bundle;
        return (_service_bundle = service.bundle) === null || _service_bundle === void 0 ? void 0 : _service_bundle.services.some((service)=>service.description);
    }, [
        (_service_bundle = service.bundle) === null || _service_bundle === void 0 ? void 0 : _service_bundle.services
    ]);
    const pureTextDescription = useMemo(()=>extractPureTextFromRichText(inlineTemplateVariableBlots(service.description)), [
        service.description
    ]);
    const hasReadMoreButton = !isMobile && showReadMoreButton && (isDescriptionOverflowing || hasBundleDescription);
    function getFullDescription() {
        return /*#__PURE__*/ _jsx(ServiceDescriptionContent, {
            description: service.description,
            includedServices: service.bundle ? service.bundle.services : null,
            testId: testId
        });
    }
    function getCutDescription() {
        return isDescriptionOverflowing && hasBundleDescription && service.description !== '' || hasReadMoreButton ? "".concat(pureTextDescription, "...") : pureTextDescription;
    }
    function handleReadMore() {
        showModal({
            biName: 'service_description_service_name_confirm',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    bi: {
                        primaryButton: {
                            name: 'service_description_confirm'
                        },
                        secondaryButton: {
                            name: 'service_description_cancel'
                        }
                    },
                    title: service.name,
                    textAlignCenter: false,
                    onPrimaryButtonClick: dismissModal,
                    onCloseButtonClick: dismissModal,
                    primaryButtonLabel: "OK",
                    content: getFullDescription()
                });
            }
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.descriptionWrapper,
        "data-testid": "".concat(testId, "service-details-description"),
        children: [
            service.description && /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                hideTooltip: true,
                className: cn(styles.description, {
                    [styles.fullWidth]: !showReadMoreButton
                }),
                ref: (el)=>el && setIsDescriptionOverflowing(el.clientWidth < el.scrollWidth),
                skin: "secondary",
                testId: testId + 'description',
                children: isMobile ? getFullDescription() : getCutDescription()
            }),
            hasReadMoreButton && /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'expand_service_description'
                },
                onClick: (e)=>{
                    e.stopPropagation();
                    handleReadMore();
                },
                className: styles.readMoreButton,
                testId: testId + 'read-more-button',
                children: "Read more"
            })
        ]
    });
}
